<div style=" display: flex; flex-direction: column;">
  <div class="ignore-darkreader" id='{{chartId}}' style="flex: 1;">
    <ng-container *ngIf="noDataAvailable">
      <div class="no-data-available">No data available.</div>
    </ng-container>
  </div>
</div>
